import { z } from "@/lib/zod";

/**
 * Esquema único del formulario de contacto.
 * Se comparte entre el cliente (react-hook-form) y la API (`/api/contact`)
 * para evitar duplicar la validación. La API valida además el campo `sent`.
 */
export const contactFormSchema = z.object({
	nombre: z.string().min(2, "El nombre es obligatorio").max(50),
	apellidos: z.string().min(2, "Los apellidos son obligatorios").max(50),
	email: z.email("Introduce un email válido"),
	tel: z
		.string()
		.optional()
		.refine((val) => !val || /^\+?[\d\s().-]{7,20}$/.test(val), {
			error: "Introduce un teléfono válido",
		}),
	ambito: z.string().min(1, "Selecciona un ámbito"),
	area: z.string().min(2, "El área es obligatoria").max(100),
	sector: z.string().min(2, "El sector es obligatorio").max(100),
	temporalidad: z.string().optional(),
	"como-nos-conociste": z.string().optional(),
	descripcion: z.string().min(10, "La descripción es obligatoria").max(500),
	"politica-privacidad": z.boolean().refine((value) => value === true, {
		error: "Debes aceptar la política de privacidad",
	}),
});

export type ContactFormData = z.infer<typeof contactFormSchema>;

/** Carga útil que recibe la API: el formulario más la marca temporal de envío. */
export const contactPayloadSchema = contactFormSchema.extend({
	sent: z.iso.datetime(),
});

export type ContactPayload = z.infer<typeof contactPayloadSchema>;
